/* eslint-disable no-useless-constructor */
import React, { Component } from "react";
import { connect } from "react-redux";
// import Loadable from "react-loadable";
// import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { get, find } from "lodash";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { MDBSpinner } from "mdbreact";
import { getFollowUpExam } from "~/store/followUpExam/actions";

import { partnerInfo } from "~/configs/partnerDetails";
const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

// const FollowUpExamMobile = Loadable({
//   loader: () =>
//     import(/* mobile */ "~/components/mobile/pages/Schedules/FollowUpExam"),
//   loading: LoadableLoading
// });
// const FollowUpExamDesktop = Loadable({
//   loader: () =>
//     import(/* desktop */ "~/components/desktop/pages/Schedules/FollowUpExam"),
//   loading: LoadableLoading
// });

class FollowUpExam extends Component {
  componentDidMount() {
    const currentRoute = window.location.href;
    this.props.getFollowUpExam(currentRoute);
  }

  styles = {
    loading: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    },

    loading_submit_booking: {
      position: "fixed",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 1000,
      backgroundColor: "black",
      opacity: 0.5
    }
  };

  render() {
    return (
      <div style={this.styles.loading_submit_booking}>
        <div style={this.styles.loading}>
          <MDBSpinner big crazy tag="div" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    }
  } = state;
  return {
    device: type
  };
};

const FollowUpExamHelmet = withTitle({
  component: FollowUpExam,
  title: `${hospitalName.value} | Lịch tái khám`
});

export default connect(mapStateToProps, { getFollowUpExam })(
  FollowUpExamHelmet
);
